<template>
    <div id="nameContainer">
      <hp5-input-text :label="label" element-id="name-criteria" class="style" required="false">
        <input v-model="criteriaContext.name" aria-required="false" />
      </hp5-input-text>
    </div>
</template>
  
<script setup>

    const { criteriaContext } = useFCPModel()
    const label = computed(() => {
        return criteriaContext.value.type === 'doctor' || criteriaContext.value.type === 'dentist' ? 'last name' : 'location name'
    })

</script>
  
<style lang="scss">
  #nameContainer {
    hp5-input-text hp5-label-decorator {
      line-height: 1.15;
    }
  }
</style>